export default __webpack_public_path__ + "static/media/icon-notes-chat.20942734.svg";